<template>
    <div 
    class="userinfo"
    :class="size"
    >
    <div class="headBox" v-if="type=='user'">
        <div :class="vipinfo&&isExpired?'isExpred':''">
            <img class="user-header" v-if="head" :src="head" alt="">
            <img class="user-header" v-else src="@/assets/images/toux.png" alt="">
            <img v-if="vipinfo&&vipinfo.viptype=='year_vip'" class="vipShow" src="@/assets/images/vip/yearVIP.png" alt="">
            <img v-if="vipinfo&&vipinfo.viptype=='day_vip'" class="vipShow" src="@/assets/images/vip/dayVIP.png" alt="">
        </div>
    </div>
    <el-image v-else 
            class="head" 
            :src="head"
            fit="cover"
        >
        <div slot="error">
            <img class="head" src="@/assets/images/toux.png" alt="">
        </div>
    </el-image>

        <div class="text">
            <div class="name">
                <div class="username">
                    {{name}}
                </div>

                <slot name="designation">
                    <div 
                    class="designation" 
                    v-if="description"
                    >
                        {{description}}
                    </div>
                </slot>
            </div>
        </div>

        <slot></slot>
    </div>
</template>

<script>
export default {
    props: {
        data: {
            type: Object,
            default: () => ({}),
        },
        size: {
            type: String,
            default: 'normal',
            //small
        },
        userhead: {
            type: String,
            default: '',
        },
        username: {
            type: String,
            default: '',
        },
        type:{
            type: String,
            default: '',
        },
        isExpired:{
            type: Boolean,
            default:true
        }
    },
    computed: {
        head() {
            if (this.userhead) {
                return this.userhead;
            }

            return this.data.head || '/upload/headportrait/2021-08/19/headportrait.jpg'
        },
        name() {
            if (this.username) {
                return this.username;
            }

            return this.data.name || this.data.addusername || this.data.nickname;
        },
        vipinfo(){
            if(this.data.vipinfo){
                return this.data.vipinfo
            }
        },
        description() {
            var marklist = this.data.marklist || [],
                firstmark = marklist[0] || {};

            return firstmark.description || '';
        }
    },
}
</script>

<style lang="scss" scoped>
    @import '@css/var.scss';

    .userinfo{
        overflow: hidden;

        &.normal {
            $headSize: 42px;
            $textSize1: 16px;
            $textSize2: 14px;

            .head{
                width: $headSize;
                height: $headSize;
            }

            .text{
                height: $headSize;
            }

            .name{
                .username {
                    font-size: $textSize1;
                    color: #333;
                }

                .designation {
                    font-size: $textSize2;
                }
            }
        }

        &.small {
            $headSize: 36px;
            $textSize1: 12px;
            $textSize2: 12px;

            .head{
                width: $headSize;
                height: $headSize;
            }

            .text{
                height: $headSize;
            }

            .name{
                .username {
                    font-size: $textSize1;
                    color: #666;
                }

                .designation {
                    font-size: $textSize2;
                }
            }
        }

        .head{
            background-color: $primaryColor1;
            position: relative;
            border-radius: 50%;
            overflow: hidden;
            float: left;
            margin-right: -50px;
        }
        .headBox{
            background-color: $primaryColor1;
            position: relative;
            border-radius: 50%;
            // overflow: hidden;
            float: left;
            margin-right: -50px;
        }

        .text{
            position: relative;
            margin-left: 60px;
        }

        .name{
            line-height: 1em;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);

            .designation {
                color: #666666;
                margin-top: 8px;
            }
        }
    }
    .user-header{
        width: 38px;
        height: 38px;
        border-radius: 50%;
        border: 2px solid rgb(250, 232, 208);
    }
    .vipShow{
        height: 20px;
        position: absolute;
        right: -14px;
        top: -2px;
        width: 20px;
        z-index: 10;
    }
    .isExpred{
        position: relative;
        .user-header{
            border: 2px solid rgba(215, 215, 215, 1);
        }
        .vipShow{
            filter: grayscale(100%);
        }
    }
</style>